import { render, staticRenderFns } from "./qhgooodReportList.vue?vue&type=template&id=9f84a95a"
import script from "./qhgooodReportList.vue?vue&type=script&lang=js"
export * from "./qhgooodReportList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports